import { Injectable } from '@angular/core';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class CompanyPopInteractionService {
  private readonly navigateToXcoSubject = new Subject<string>();
  private pendingXcoId: string | null = null;

  readonly navigateToXco$ = this.navigateToXcoSubject.asObservable();

  requestNavigateToXco(xcoId: string): void {
    this.pendingXcoId = xcoId;
    this.navigateToXcoSubject.next(xcoId);
  }

  consumePendingXco(): string | null {
    const id = this.pendingXcoId;
    this.pendingXcoId = null;
    return id;
  }
}
